var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.user.company_type == 'enterprise')?_c('enterprise-team'):_vm._e(),(_vm.$store.state.user.company_type == 'ecosystem')?_c('ecosystem-team'):_vm._e(),(_vm.$store.state.user.company_type == 'startup')?_c('startup-team'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }